export const DashboardBaseSteps = [


  {
    target: '.MuiPageTitle-wrapper > .MuiGrid-container  > .MuiBox-root > .MuiGrid-item:nth-child(1) ',
    spotlightClicks: true,
    content: 'Select one or more Information Channels like Orders, Returns, To Ship, Shipped',
  },
  {
    target: '.MuiPageTitle-wrapper > .MuiGrid-container  > .MuiBox-root > .MuiGrid-item:nth-child(2) ',
    content: 'Select a period for the Dashboard, like Week, Month or Year',
  },
  {
    target: '.MuiPageTitle-wrapper > .MuiGrid-container  > .MuiBox-root > .MuiGrid-item:nth-child(3) ',
    content: 'You can look at either the number of orders or their currency values',
  },
  {
    target: '.order-chart ',
    content: 'This Graph gives you an overview of the orders, returns and more in the selected period',
  },
  {
    target: '.Kpi2 ',
    content: 'For a high level overview of the KPIs, check out this section',
  },
  {
    target: '.sidebar-layout-content ',
    placement: 'right',
    content: 'To start using the rest of the site, use this menu to navigate to other sections',
  },

]

export const DashboardPurchasingSteps = [

  {
    target: ".menu-item-purchasing button",
    spotlightClicks: true,
    content: "For managing the purchasing process, use this section"
  },
  //submenu-item-purchase-order
  {
    target: ".submenu-item-purchase-order",
    content: "To create a new purchase order, click here"
  },
  //submenu-item-purchase-order-draft
  {
    target: ".submenu-item-purchase-order-draft",
    content: "To view draft purchase orders, click here"
  },
  //submenu-item-backorders
  {
    target: ".submenu-item-backorders",
    content: "A list of things that need to be ordered is available here"
  },
  //submenu-item-low-order-points
  {
    target: ".submenu-item-low-order-points",
    content: "To set up automatic order flows and notifications based on stock levels, click here"
  },
//submenu-item-suppliers
  {
    target: ".menu-item-purchasing .submenu-item-suppliers",
    content: "To manage suppliers, click here"
  },

]